jQuery(document).ready(function ($) {

  const toggleFaqBlock = (e) => {
    const target = e.target.parentElement
    target.classList.toggle("open")
    const content = target.getElementsByClassName("content")[0]

    if (target.classList.contains("open"))
      content.style.height = content.scrollHeight + 'px'
    else
      content.style.height = 0
  }

  //EVENT
  $(".faq-block-item .title").on("click", toggleFaqBlock)

});